import React, { useContext } from "react";
import { Avatar, Box, Button, ButtonGroup, Divider, Flex, IconButton, Spacer } from "@chakra-ui/react";
import logo from "../assets/cahm-crm-logo.png";
import { Icon } from "@chakra-ui/icons";
import { MdLogout } from "react-icons/md";
import { store } from "../helper/Store";
import { useAuth } from "../api/AuthProvider";
import ExecutiveNavigationBar from "./ExecutiveNavigationBar";
import DetailNavigationBar from "./DetailNavigationBar";

const AppHeader = ({ matrix1Ref, matrix2Ref, matrix3Ref, matrix4Ref, matrix5Ref, matrix6Ref, matrix7Ref, matrix8Ref, matrix9Ref }) => {
    const globalState = useContext(store);
    const { state, dispatch } = globalState;
    const auth = useAuth();

    const handleTabCahnge = (index) => {
        switch (index) {
            case 0:
                dispatch({ type: 'set_navigation', navigation: "home" });
                break;
            case 1:
                matrix1Ref.current.scrollIntoView({ behavior: "smooth" });
                break;
            case 2:
                matrix2Ref.current.scrollIntoView({ behavior: "smooth" });
                break;
            case 3:
                matrix3Ref.current.scrollIntoView({ behavior: "smooth" });
                break;
            case 4:
                matrix4Ref.current.scrollIntoView({ behavior: "smooth" });
                break;
            case 5:
                matrix5Ref.current.scrollIntoView({ behavior: "smooth" });
                break;
            case 6:
                matrix6Ref.current.scrollIntoView({ behavior: "smooth" });
                break;
            case 7:
                matrix7Ref.current.scrollIntoView({ behavior: "smooth" });
                break;
            case 8:
                matrix8Ref.current.scrollIntoView({ behavior: "smooth" });
                break;
            case 9:
                matrix9Ref.current.scrollIntoView({ behavior: "smooth" });
                break;
            default:
                break;
        }
    };

    const navigationBar = {
        executive: <ExecutiveNavigationBar onHandleTabChange={(index) => handleTabCahnge(index === 0 ? index : index + 4)} />,
        detail: <DetailNavigationBar onHandleTabChange={(index) => handleTabCahnge(index)} />
    };

    const RenderNavigation = () => {
        if ( state.isLoggedIn ) {
            if ( state.navigation !== "home" ) {
                return navigationBar[state.navigation];
            }
        }
    };

    return (
        <Box
            borderBottom={1}
            position='fixed'
            width='100%'
            zIndex={10000}
            bgImage='linear-gradient(180deg, #f5f2eb, white, #f5f2eb)'
        >
            <Flex>
                <Box style={{ ...styles.container, paddingTop: 25, paddingBottom: 25 }}>
                    <img src={logo} width={150} height={27} alt="cahm-logo" />
                </Box>
                <Spacer />
                <Box
                    sx={{
                        alignSelf: 'center'
                    }}
                >
                    {state.isLoggedIn &&
                        <ButtonGroup spacing='0'>
                            <Button variant='ghost' size='lg' ><Avatar name={auth.userData.username} />&nbsp;&nbsp;&nbsp;{auth.userData.username}</Button>
                            <IconButton aria-label='Logout' variant='ghost' size='lg' isRound={true} icon={<Icon as={MdLogout} boxSize={6} />} onClick={auth.logout} />
                        </ButtonGroup>
                    }
                </Box>
            </Flex>
            <Divider />
            {RenderNavigation()}
        </Box>
    );
};

const styles = {

    container: {
        fontFamily: 'sans-serif',
        padding: 10,
        alignContent: 'center',

    }
};

export default AppHeader;